import React from 'react'
import { Link } from 'react-router-dom'
import Card from '../components/Card'

export default function Directory() {
  return (
    // <div className="container">
    //   <section className="card">
    //     <div style={{display:'flex', gap:12, flexWrap:'wrap'}}>
    //       <input placeholder="Search bookkeepers, software, or skill" style={{padding:12, borderRadius:8, border:'1px solid #eef6ff', flex:1}}/>
    //       <select style={{padding:12, borderRadius:8, border:'1px solid #eef6ff', maxWidth:220}}>
    //         <option>All specialties</option>
    //         <option>Taxes</option>
    //         <option>QuickBooks</option>
    //         <option>Payroll</option>
    //       </select>
    //       <select style={{padding:12, borderRadius:8, border:'1px solid #eef6ff', maxWidth:180}}>
    //         <option>Sort: Recommended</option>
    //         <option>Highest rated</option>
    //         <option>Lowest price</option>
    //       </select>
    //     </div>

    //     <div style={{display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:16, marginTop:16}}>
    //       <Card>
    //         <div style={{display:'flex', gap:12, alignItems:'center'}}>
    //           <div style={{width:64, height:64, borderRadius:12, background:'#f1f6ff'}} />
    //           <div>
    //             <div style={{fontWeight:700}}>Sarah P.</div>
    //             <div className="kv">Taxes • QuickBooks • Small Business</div>
    //           </div>
    //           <div style={{marginLeft:'auto', textAlign:'right'}}>
    //             <div style={{fontWeight:700, color:'var(--accent-600)'}}>$45/hr</div>
    //             <Link to="/profile/1" className="btn ghost" style={{marginTop:8}}>View</Link>
    //           </div>
    //         </div>
    //       </Card>

    //       <Card>
    //         <div style={{display:'flex', gap:12, alignItems:'center'}}>
    //           <div style={{width:64, height:64, borderRadius:12, background:'#f1f6ff'}} />
    //           <div><div style={{fontWeight:700}}>Ryan S.</div><div className="kv">Small Business • Payroll</div></div>
    //           <div style={{marginLeft:'auto'}}><div style={{fontWeight:700, color:'var(--accent-600)'}}>$50/hr</div><Link to="/profile/2" className="btn ghost" style={{marginTop:8}}>View</Link></div>
    //         </div>
    //       </Card>

    //       <Card>
    //         <div style={{display:'flex', gap:12, alignItems:'center'}}>
    //           <div style={{width:64, height:64, borderRadius:12, background:'#f1f6ff'}} />
    //           <div><div style={{fontWeight:700}}>April C.</div><div className="kv">Personal Finance</div></div>
    //           <div style={{marginLeft:'auto'}}><div style={{fontWeight:700, color:'var(--accent-600)'}}>$60/hr</div><Link to="/profile/3" className="btn ghost" style={{marginTop:8}}>View</Link></div>
    //         </div>
    //       </Card>
    //     </div>

    //     <div style={{textAlign:'center', marginTop:12}}>
    //       <button className="btn ghost">Load more</button>
    //     </div>
    //   </section>
    // </div>
    <div className="container">
      <section className="card">
        <h2 className="h2">How it works</h2>

        <div style={{display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:12, marginTop:12}}>
          <Card><div style={{fontWeight:700}}>1. Create an account</div><div className="kv">Sign up and tell us a bit about yourself or your business.</div></Card>
          <Card><div style={{fontWeight:700}}>2. Find the project support you need</div><div className="kv"><Link to="/directory">Product Offerings</Link></div></Card>
          <Card><div style={{fontWeight:700}}>3. Chat & collaborate with our team</div><div className="kv">Use in-app messaging to discuss details and ask questions.</div></Card>

          {/* <Card><div style={{fontWeight:700}}>3. Chat and collaborate with our team members</div><div className="kv">Securely upload receipts, statements and invoices.</div></Card> */}
        </div>

        <div style={{display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:12, marginTop:12}}>
          <Card><div style={{fontWeight:700}}>4. Recurring or non-recurring</div><div className="kv">Support services that is expected to recur over a period of time or one-time support services. </div></Card>
          <Card><div style={{fontWeight:700}}>5. Review and Approve Project Delivery</div><div className="kv">Approve the delivered work </div></Card>
          <Card><div style={{fontWeight:700}}>6. Approve and Pay</div><div className="kv">Discuss and agree on payment terms and support service fee.</div></Card>
        </div>
      </section>
    </div>
  )
}
